// extracted by mini-css-extract-plugin
export default {"header":"Haader_header__YCYem"};